module.exports = __webpack_public_path__ + "img/park-operation.75943717.jpg";